import { decodeHtmlCharCode } from './html'

export const normalize = (value: string) => {
  return decodeHtmlCharCode(value)
}
